import { ActionTypes } from "../constants/index";

export default function demo(state = {}, action) {
	switch (action.type) {
		case ActionTypes.SET_DEMO_DATA:
			return Object.assign({}, state, {
				demoData: action.demoData,
			});

		default:
			return state;
	}
}
